/**
 * El idioma y el tema, al final de las pantallas de entrar.
 *
 * ABAJO Y NO ARRIBA. Estaban encima del formulario, que es donde alguien
 * mira primero: dos controles que casi nadie toca, ocupando el lugar de lo
 * único que se vino a hacer. Al final quedan donde se busca lo accesorio —y
 * es donde los ponen las aplicaciones que hacen esto bien— sin desaparecer.
 *
 * EN PÍLDORA Y CON ÍCONO, sin etiqueta escrita: dos palabras («Idioma»,
 * «Tema») encima de dos campos chicos ocupaban cuatro renglones para decir
 * algo que un globo y un círculo mitad lleno dicen sin texto. Lo que se lee
 * en voz alta sigue estando, en `aria-label`.
 *
 * DENTRO DE LA APLICACIÓN ESTO NO EXISTE: el idioma vive en «Mi perfil» y el
 * tema en «Más», que es donde se guardan de verdad —viajan con la cuenta y
 * no con el navegador—. Acá hacen falta porque quien todavía no entró no
 * tiene ni perfil ni cuenta.
 */
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, THEMES, type SupportedLocale, type Theme } from '@tennisup/contracts';

import { GlobeIcon, ThemeIcon } from './icons';
import { Select } from './Select';
import { changeLocale } from '../i18n';
import { useTheme } from '../theme/ThemeProvider';

export function Switcher(): JSX.Element {
  const { t, i18n } = useTranslation();
  const { theme, setTheme } = useTheme();

  return (
    <div className="switcher-row">
      <span className="switcher-pill">
        <GlobeIcon title="" size={18} />
        <Select
          id="switch-language"
          aria-label={t('switcher.language')}
          value={i18n.language as SupportedLocale}
          options={SUPPORTED_LOCALES.map((locale) => ({
            value: locale,
            label: t(`language.${locale}`),
          }))}
          onChange={(locale) => void changeLocale(locale)}
        />
      </span>

      <span className="switcher-pill">
        <ThemeIcon title="" size={18} />
        <Select
          id="switch-theme"
          aria-label={t('switcher.theme')}
          value={theme}
          options={THEMES.map((value) => ({ value, label: t(`theme.${value}`) }))}
          onChange={(value: Theme) => setTheme(value)}
        />
      </span>
    </div>
  );
}
